import React from "react";
var __jsx = React.createElement;
import DocumentsAndForms from './DocumentsAndForms';
function DocumentsAndFormsAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(DocumentsAndForms, {
    documentFormsData: entry,
    className: "download-form"
  });
}
export default DocumentsAndFormsAdapter;